import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { CdkPortalOutlet, Portal } from '@angular/cdk/portal';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.html',
    styleUrl: './navbar.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, MatButtonModule, MatIconModule, MatMenuModule, CdkPortalOutlet],
})
export class Navbar {
    readonly username: InputSignal<string> = input.required();
    readonly orgName: InputSignal<string> = input.required();
    readonly portal: InputSignal<Portal<unknown> | null> = input(null);
    readonly logout: OutputEmitterRef<void> = output();
}
